(() => {
  const normalize = (value = '') => value.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();

  const CATEGORY_RULES = [
    ['powdercoat', ['powdercoat', 'powder coat', 'powder coating']],
    ['cast-metals', ['cast metal', 'cast aluminium', 'cast aluminum', 'cast bronze', 'cast brass']],
    ['fiberglass', ['fibreglass', 'fiberglass', 'fibre glass', 'fiber glass']],
    ['upholstery', ['upholstery', 'fabric', 'textile', 'leather', 'mohair', 'boucle', 'bouclé', 'velvet', 'wool']],
    ['timber', ['timber', 'wood', 'veneer', 'ash', 'oak', 'walnut']],
    ['metals', ['metal', 'aluminium', 'aluminum', 'steel', 'stainless', 'brass', 'bronze', 'chrome', 'nickel']]
  ];

  const COLOUR_RULES = [
    ['White / Cream', ['white', 'cream', 'ivory', 'bone', 'chalk', 'snow', 'pearl', 'off white', 'arborio', 'mastice']],
    ['Beige / Tan', ['beige', 'tan', 'sand', 'camel', 'oat', 'biscuit', 'nude', 'linen', 'natural']],
    ['Brown', ['brown', 'chocolate', 'cocoa', 'walnut', 'chestnut', 'tobacco', 'coffee', 'umber', 'rust']],
    ['Black', ['black', 'charcoal', 'ebony', 'ink', 'nero']],
    ['Grey / Silver', ['grey', 'gray', 'silver', 'graphite', 'smoke', 'stone', 'aluminium', 'aluminum', 'stainless', 'steel', 'chrome']],
    ['Green', ['green', 'olive', 'sage', 'moss', 'forest', 'eucalyptus']],
    ['Blue', ['blue', 'navy', 'cobalt', 'denim', 'ocean', 'sky']],
    ['Red / Pink', ['red', 'burgundy', 'wine', 'oxblood', 'pink', 'blush', 'rose', 'terracotta']],
    ['Yellow / Orange', ['yellow', 'ochre', 'mustard', 'orange', 'amber']],
    ['Gold / Bronze', ['gold', 'brass', 'bronze']]
  ];

  const FINISH_RULES = [
    ['Polished', ['polished', 'polish']],
    ['Brushed', ['brushed', 'brush finish']],
    ['Satin', ['satin']],
    ['Matte', ['matte', 'matt']],
    ['Gloss', ['gloss', 'glossy']],
    ['Raw', ['raw']],
    ['Anodised', ['anodised', 'anodized', 'anodic']],
    ['Powdercoat', ['powdercoat', 'powder coat', 'powder coating']],
    ['Textured', ['textured', 'texture']],
    ['Natural', ['natural finish', 'natural timber', 'natural ash', 'natural oak']],
    ['Oiled / Waxed', ['oiled', 'oil finish', 'waxed', 'wax finish']]
  ];

  const injectStyles = () => {
    if (document.getElementById('fomu-material-library-filter-styles')) return;
    const style = document.createElement('style');
    style.id = 'fomu-material-library-filter-styles';
    style.textContent = `
      .fomu-material-library--filterable .fomu-material-library__categories { display: none; }
      .fomu-material-library__finder { margin-top: 68px; }
      .fomu-material-library__search-wrap { position: relative; max-width: 100%; border-bottom: 1px solid currentColor; }
      .fomu-material-library__search { width: 100%; padding: 14px 42px 14px 0; border: 0; border-radius: 0; outline: 0; background: transparent; color: inherit; font: inherit; font-size: clamp(18px, 1.45vw, 23px); line-height: 1.35; appearance: none; }
      .fomu-material-library__search::placeholder { color: currentColor; opacity: .48; }
      .fomu-material-library__search-clear { position: absolute; right: 0; top: 50%; transform: translateY(-50%); border: 0; background: transparent; color: inherit; font: inherit; font-size: 21px; line-height: 1; padding: 8px 0 8px 12px; cursor: pointer; opacity: 0; pointer-events: none; }
      .fomu-material-library__search-clear.is-visible { opacity: 1; pointer-events: auto; }
      .fomu-material-library__tabs { display: flex; flex-wrap: wrap; gap: 10px 26px; margin-top: 34px; }
      .fomu-material-library__tab { padding: 0 0 3px; border: 0; border-bottom: 1px solid transparent; background: transparent; color: inherit; font: inherit; cursor: pointer; }
      .fomu-material-library__tab:hover, .fomu-material-library__tab:focus-visible, .fomu-material-library__tab[aria-pressed='true'] { border-bottom-color: currentColor; }
      .fomu-material-library__filters { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)) auto; gap: 14px 20px; align-items: end; margin-top: 36px; padding-top: 24px; border-top: 1px solid rgba(20,19,17,.22); }
      .fomu-material-library__field { display: grid; gap: 8px; }
      .fomu-material-library__field label { font-size: 12px; line-height: 1.2; opacity: .7; }
      .fomu-material-library__select { width: 100%; padding: 7px 28px 7px 0; border: 0; border-bottom: 1px solid rgba(20,19,17,.46); border-radius: 0; background: transparent; color: inherit; font: inherit; font-size: 14px; line-height: 1.4; }
      .fomu-material-library__clear { padding: 7px 0; border: 0; border-bottom: 1px solid currentColor; background: transparent; color: inherit; font: inherit; font-size: 14px; line-height: 1.4; cursor: pointer; white-space: nowrap; }
      .fomu-material-library__meta { display: flex; justify-content: space-between; gap: 24px; align-items: baseline; margin-top: 22px; font-size: 13px; line-height: 1.4; }
      .fomu-material-library__no-results { margin: 70px 0 0; font-size: clamp(18px, 1.45vw, 23px); line-height: 1.35; }
      .fomu-material-library__no-results[hidden] { display: none; }
      .fomu-material-library__card[hidden], .fomu-material-library__group[hidden], .fomu-material-library__division-heading[hidden] { display: none !important; }
      .fomu-material-library--filterable .fomu-material-library__finder + .fomu-material-library__groups { margin-top: 72px; }
      @media (max-width: 989px) {
        .fomu-material-library__filters { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .fomu-material-library__clear { justify-self: start; }
      }
      @media (max-width: 749px) {
        .fomu-material-library__finder { margin-top: 46px; }
        .fomu-material-library__search { padding-top: 11px; padding-bottom: 11px; font-size: 17px; }
        .fomu-material-library__tabs { flex-wrap: nowrap; overflow-x: auto; margin-right: calc(var(--fomu-catalog-gutter) * -1); padding-right: var(--fomu-catalog-gutter); padding-bottom: 5px; gap: 18px; scrollbar-width: none; }
        .fomu-material-library__tabs::-webkit-scrollbar { display: none; }
        .fomu-material-library__tab { flex: 0 0 auto; font-size: 13px; }
        .fomu-material-library__filters { grid-template-columns: 1fr; gap: 17px; margin-top: 28px; }
        .fomu-material-library__field label { font-size: 11px; }
        .fomu-material-library__select, .fomu-material-library__clear { font-size: 13px; }
        .fomu-material-library__meta { margin-top: 18px; font-size: 12px; }
        .fomu-material-library--filterable .fomu-material-library__finder + .fomu-material-library__groups { margin-top: 58px; }
      }
    `;
    document.head.appendChild(style);
  };

  const detectCategory = (text) => {
    const haystack = normalize(text);
    for (const [key, words] of CATEGORY_RULES) {
      if (words.some((word) => haystack.includes(normalize(word)))) return key;
    }
    return 'other';
  };

  const detectValues = (text, rules) => {
    const haystack = normalize(text);
    return rules.filter(([, words]) => words.some((word) => haystack.includes(normalize(word)))).map(([label]) => label);
  };

  const addOptions = (select, values) => {
    [...values].sort((a, b) => a.localeCompare(b)).forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  };

  const setupFinder = (library) => {
    const groupsContainer = library.querySelector('.fomu-material-library__groups');
    if (!groupsContainer || library.querySelector('.fomu-material-library__finder')) return;

    const groupElements = [...groupsContainer.querySelectorAll('.fomu-material-library__group')];
    const divisionHeadings = [...groupsContainer.querySelectorAll('.fomu-material-library__division-heading')];
    const groupData = new Map();
    let currentDivision = '';

    [...groupsContainer.children].forEach((child) => {
      if (child.classList.contains('fomu-material-library__division-heading')) {
        currentDivision = child.querySelector('h2')?.textContent?.trim() || '';
      }
      if (child.classList.contains('fomu-material-library__group')) {
        groupData.set(child, { division: currentDivision });
      }
    });

    const cards = [...library.querySelectorAll('.fomu-material-library__card')].map((card) => {
      const groupEl = card.closest('.fomu-material-library__group');
      const groupName = groupEl?.querySelector('h2')?.textContent?.trim() || '';
      const division = groupData.get(groupEl)?.division || '';
      const title = card.querySelector('h3')?.textContent?.trim() || '';
      const description = card.querySelector('.fomu-material-library__description')?.textContent?.trim() || '';
      const image = card.querySelector('img');
      const imageAlt = image?.alt || '';
      const imageSrc = image?.getAttribute('src') || image?.getAttribute('srcset') || '';
      const searchable = `${title} ${description} ${groupName} ${division} ${imageAlt} ${imageSrc}`;
      const category = detectCategory(`${division} ${groupName} ${searchable}`);
      const colours = detectValues(searchable, COLOUR_RULES);
      const finishes = detectValues(searchable, FINISH_RULES);
      return { card, groupEl, groupName, division, searchable: normalize(searchable), category, colours, finishes };
    });

    const finder = document.createElement('div');
    finder.className = 'fomu-material-library__finder';
    finder.innerHTML = `
      <div class="fomu-material-library__search-wrap">
        <input class="fomu-material-library__search" type="search" autocomplete="off" spellcheck="false" aria-label="Search materials" placeholder="Search materials, colours or finishes…">
        <button class="fomu-material-library__search-clear" type="button" aria-label="Clear material search">×</button>
      </div>
      <div class="fomu-material-library__tabs" aria-label="Material categories"></div>
      <div class="fomu-material-library__filters">
        <div class="fomu-material-library__field">
          <label>Colour</label>
          <select class="fomu-material-library__select" data-filter="colour"><option value="">All colours</option></select>
        </div>
        <div class="fomu-material-library__field">
          <label>Finish</label>
          <select class="fomu-material-library__select" data-filter="finish"><option value="">All finishes</option></select>
        </div>
        <div class="fomu-material-library__field">
          <label>Range / supplier</label>
          <select class="fomu-material-library__select" data-filter="range"><option value="">All ranges</option></select>
        </div>
        <button class="fomu-material-library__clear" type="button">Clear filters</button>
      </div>
      <div class="fomu-material-library__meta">
        <span class="fomu-material-library__count" aria-live="polite"></span>
      </div>
      <p class="fomu-material-library__no-results" hidden>No materials match those filters. Try clearing a filter or using a broader search.</p>
    `;

    groupsContainer.before(finder);
    library.classList.add('fomu-material-library--filterable');

    const tabs = finder.querySelector('.fomu-material-library__tabs');
    const search = finder.querySelector('.fomu-material-library__search');
    const searchClear = finder.querySelector('.fomu-material-library__search-clear');
    const colourSelect = finder.querySelector('[data-filter="colour"]');
    const finishSelect = finder.querySelector('[data-filter="finish"]');
    const rangeSelect = finder.querySelector('[data-filter="range"]');
    const clearFilters = finder.querySelector('.fomu-material-library__clear');
    const count = finder.querySelector('.fomu-material-library__count');
    const noResults = finder.querySelector('.fomu-material-library__no-results');

    const categoryLabels = [
      ['all', 'All'],
      ['upholstery', 'Upholstery'],
      ['timber', 'Timber'],
      ['metals', 'Metals'],
      ['powdercoat', 'Powdercoat'],
      ['cast-metals', 'Cast Metals'],
      ['fiberglass', 'Fiberglass']
    ];

    let activeCategory = 'all';
    categoryLabels.forEach(([key, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fomu-material-library__tab';
      button.dataset.category = key;
      button.textContent = label;
      button.setAttribute('aria-pressed', key === 'all' ? 'true' : 'false');
      tabs.appendChild(button);
    });

    const availableColours = new Set(cards.flatMap((item) => item.colours));
    const availableFinishes = new Set(cards.flatMap((item) => item.finishes));
    const ranges = new Set(cards.map((item) => item.groupName).filter(Boolean));
    addOptions(colourSelect, availableColours);
    addOptions(finishSelect, availableFinishes);
    addOptions(rangeSelect, ranges);

    const refreshDivisions = () => {
      divisionHeadings.forEach((heading, index) => {
        const nextHeading = divisionHeadings[index + 1];
        const children = [...groupsContainer.children];
        const start = children.indexOf(heading);
        const end = nextHeading ? children.indexOf(nextHeading) : children.length;
        let hasVisibleGroup = false;
        for (let i = start + 1; i < end; i += 1) {
          const child = children[i];
          if (child?.classList?.contains('fomu-material-library__group') && !child.hidden) {
            hasVisibleGroup = true;
            break;
          }
        }
        heading.hidden = !hasVisibleGroup;
      });
    };

    const applyFilters = () => {
      const query = normalize(search.value);
      const colour = colourSelect.value;
      const finish = finishSelect.value;
      const range = rangeSelect.value;
      let visibleCount = 0;

      cards.forEach((item) => {
        const matchesCategory = activeCategory === 'all' || item.category === activeCategory;
        const matchesSearch = !query || query.split(' ').every((term) => item.searchable.includes(term));
        const matchesColour = !colour || item.colours.includes(colour);
        const matchesFinish = !finish || item.finishes.includes(finish);
        const matchesRange = !range || item.groupName === range;
        const visible = matchesCategory && matchesSearch && matchesColour && matchesFinish && matchesRange;
        item.card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groupElements.forEach((groupEl) => {
        groupEl.hidden = ![...groupEl.querySelectorAll('.fomu-material-library__card')].some((card) => !card.hidden);
      });

      refreshDivisions();
      count.textContent = `${visibleCount} ${visibleCount === 1 ? 'material' : 'materials'}`;
      noResults.hidden = visibleCount !== 0;
      searchClear.classList.toggle('is-visible', Boolean(search.value));
    };

    let searchTimer;
    search.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(applyFilters, 80);
    });

    searchClear.addEventListener('click', () => {
      search.value = '';
      search.focus();
      applyFilters();
    });

    tabs.addEventListener('click', (event) => {
      const button = event.target.closest('.fomu-material-library__tab');
      if (!button) return;
      activeCategory = button.dataset.category || 'all';
      tabs.querySelectorAll('.fomu-material-library__tab').forEach((tab) => {
        tab.setAttribute('aria-pressed', tab === button ? 'true' : 'false');
      });
      applyFilters();
    });

    [colourSelect, finishSelect, rangeSelect].forEach((select) => select.addEventListener('change', applyFilters));

    clearFilters.addEventListener('click', () => {
      activeCategory = 'all';
      search.value = '';
      colourSelect.value = '';
      finishSelect.value = '';
      rangeSelect.value = '';
      tabs.querySelectorAll('.fomu-material-library__tab').forEach((tab) => {
        tab.setAttribute('aria-pressed', tab.dataset.category === 'all' ? 'true' : 'false');
      });
      applyFilters();
    });

    applyFilters();
  };

  const setupLightbox = (library) => {
    const dialog = library.querySelector('.fomu-material-lightbox');
    const largeImage = dialog?.querySelector('.fomu-material-lightbox__image-wrap img');
    const title = dialog?.querySelector('.fomu-material-lightbox__title');
    const group = dialog?.querySelector('.fomu-material-lightbox__group');
    const description = dialog?.querySelector('.fomu-material-lightbox__description');
    const closeButton = dialog?.querySelector('.fomu-material-lightbox__close');

    if (!dialog || !largeImage || !title || !group || !description || !closeButton) return;

    const closeDialog = () => {
      dialog.close();
      document.documentElement.classList.remove('fomu-material-lightbox-open');
    };

    const openDialog = (image) => {
      const card = image.closest('.fomu-material-library__card');
      const materialGroup = image.closest('.fomu-material-library__group');
      const materialTitle = card?.querySelector('h3')?.textContent?.trim() || image.alt;
      largeImage.src = image.currentSrc || image.src;
      largeImage.alt = materialTitle;
      title.textContent = materialTitle;
      group.textContent = materialGroup?.querySelector('h2')?.textContent?.trim() || '';
      description.textContent = card?.querySelector('.fomu-material-library__description')?.textContent?.trim() || '';
      dialog.showModal();
      document.documentElement.classList.add('fomu-material-lightbox-open');
      closeButton.focus();
    };

    library.querySelectorAll('.fomu-material-library__image img').forEach((image) => {
      const materialTitle = image.closest('.fomu-material-library__card')?.querySelector('h3')?.textContent?.trim() || image.alt;
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', `View ${materialTitle} larger`);
      image.addEventListener('click', () => openDialog(image));
      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openDialog(image);
        }
      });
    });

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('fomu-material-lightbox-open'));
  };

  injectStyles();
  document.querySelectorAll('.fomu-material-library').forEach((library) => {
    setupFinder(library);
    setupLightbox(library);
  });
})();
